import React, { useEffect, useState } from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    CircularProgress,
    Stack,
    TextField,
    InputAdornment,
    Box,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download'; // Updated icon
import SearchIcon from '@mui/icons-material/Search';
import { useContent } from '../../../../context/ContentContext';
import ReactPlayer from 'react-player';
import download from 'downloadjs'; // Import downloadjs
import axiosInstance from '../../../../utils/axiosInstance';

const MarketingKitDisplay = () => {
    const { marketingKitData, loading, error } = useContent();
    const [searchQuery, setSearchQuery] = useState('');

    const downloadMarketingKit = async (kitId) => {
        try {
            console.log(`Downloading marketing kit with ID: ${kitId}`);

            // Construct the API endpoint URL for downloading
            const downloadUrl = `/api/marketing-kit/download/${kitId}`;

            // Make the GET request using axiosInstance
            const response = await axiosInstance.get(downloadUrl, {
                responseType: 'blob', // Ensure binary data is handled
            });

            // Extract the filename from the Content-Disposition header
            const contentDisposition = response.headers['content-disposition'];
            const filename = contentDisposition
                ? contentDisposition.split('filename=')[1]?.replace(/"/g, '') || 'downloaded-file'
                : 'downloaded-file';

            // Use downloadjs to save the file locally
            download(response.data, filename);
            console.log('File downloaded successfully:', filename);
        } catch (err) {
            console.error('Error downloading marketing kit:', err);
            alert(err.response?.data?.message || 'Failed to download the marketing kit. Please try again.');
        }
    };

    if (loading) {
        return (
            <Stack
                sx={{ width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center' }}
                direction="column"
            >
                <CircularProgress />
            </Stack>
        );
    }

    if (!marketingKitData || marketingKitData.length === 0) {
        return (
            <Stack
                sx={{ width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center' }}
                direction="column"
                spacing={2}
            >
                <Typography variant="h6">Tidak ada marketing kit yang tersedia</Typography>
                <img
                    src="/images/NoResultFound.webp"
                    alt="No Marketing Kit Found"
                    style={{ width: '300px', height: 'auto' }}
                />
            </Stack>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <Box
                sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    backgroundColor: 'transparent',
                    padding: '8px',
                    marginBottom: 2,
                    width: '100%',
                }}
            >
                <TextField
                    label="Search Marketing Kits"
                    variant="outlined"
                    fullWidth
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        },
                    }}
                />
            </Box>

            <Box sx={{ flex: 1, overflowY: 'auto', width: '100%' }}>
                <Stack spacing={3} sx={{ p: 2 }}>
                    {marketingKitData.map((kit) => (
                        <Card
                            key={kit.id}
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'column' },
                                alignItems: 'center',
                                padding: 2,
                            }}
                        >
                            <CardContent sx={{ flex: 1, textAlign: { xs: 'center', sm: 'left' } }}>
                                <Typography variant="h6" gutterBottom>
                                    {kit.title}
                                </Typography>
                            </CardContent>
                            <Stack
                                sx={{
                                    width: '100%',
                                    paddingTop: 2,
                                    position: 'relative',
                                    height: 0,
                                    paddingBottom: '177%',
                                }}
                            >
                                <ReactPlayer
                                    url={kit.file}
                                    controls
                                    width="100%"
                                    height="100%"
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        objectFit: 'contain',
                                    }}
                                />
                            </Stack>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                startIcon={<DownloadIcon />}
                                onClick={() => downloadMarketingKit(kit.id)} // Call the download function
                            >
                                Download
                            </Button>
                        </Card>
                    ))}
                </Stack>
            </Box>
        </Box>
    );
};

export default MarketingKitDisplay;
